<template>
  <el-card shadow="never" v-loading="loading">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item
          v-if="$root.state.facility"
          :to="{ name: 'Facility Todo' }"
        >
            {{String($root.state.facilityData.code).toUpperCase()}} To Dos
          </el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-card shadow="never">
      <template slot="header">
        Todos
        <el-button
          class="add-button"
          type="primary"
          icon="el-icon-plus"
          circle
          @click="() => addTodoDialog = true"
        >
        </el-button>
      </template>
      <el-table :data="todos">
        <el-table-column prop="title" label="Title"></el-table-column>
        <el-table-column prop="detail" label="Detail"></el-table-column>
        <el-table-column prop="completed" label="Completed"></el-table-column>
        <el-table-column prop="assignedTo" label="Assigned To"></el-table-column>
        <el-table-column prop="createdBy" label="Created By"></el-table-column>
      </el-table>
    </el-card>
    <el-divider></el-divider>
    <el-card shadow="never">
      <template slot="header">
        Pending Lease
      </template>
      <el-table :data="pendingLeases" @row-click="routeToCustomer">
        <el-table-column prop="customer.company" label="Customer">
        </el-table-column>
        <el-table-column prop="unitNames" label="Units">
        </el-table-column>
        <el-table-column prop="start" label="Start Date">
          <template slot-scope="scope">
            {{
              scope.row.start | formatDate
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="Amount"
          :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
        ></el-table-column>
        <el-table-column
          prop="amountPaid"
          label="Amount Paid"
          :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
        ></el-table-column>
        <!-- <el-table-column prop="deposit" label="Deposit">
          <template slot-scope="scope">
            {{
              Number(scope.row.deposit).toLocaleString('en', { style: 'currency', currency: 'USD' })
            }}
          </template>
        </el-table-column>
        <el-table-column prop="depositPaid" label="Deposit Paid">
          <template slot-scope="scope">
            {{
              Number(scope.row.depositPaid || 0).toLocaleString('en', { style: 'currency', currency: 'USD' })
            }}
          </template>
        </el-table-column> -->
        <el-table-column prop="status" label="Status"></el-table-column>
        <el-table-column prop="statusReason" label="Computed Status Reason" width="250"></el-table-column>
        <el-table-column prop="createdBy" label="Created By"></el-table-column>
      </el-table>
    </el-card>
    <el-dialog :visible.sync="addTodoDialog" destroy-on-close>
      <AddTodo @done="addedTodo"/>
    </el-dialog>
  </el-card>
</template>

<script>
import axios from 'axios';
import { ADMIN_API_BASE, CUSTOMER_API_BASE, UNITS_API_BASE } from '../env';
import AddTodo from './AddTodo.vue';

export default {
  name: 'FacilityTodos',
  components: { AddTodo },
  props: {
    facility: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      todos: [],
      addTodoDialog: false,
      pendingLeases: [],
    };
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getFacilityTodos();
      await this.getFacilityPendingLease();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getFacilityTodos();
    await this.getFacilityPendingLease();
    this.loading = false;
  },
  methods: {
    routeToCustomer(row) {
      this.$router.push({ name: 'Facility Customer', params: { id: row.customerId, facility: this.facility } });
    },
    async getFacilityPendingLease() {
      const response = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/customer/facility/invoices/${this.facility}`, {
        params: {
          status: 'PENDING',
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      // eslint-disable-next-line no-restricted-syntax
      for (const lease of response.data) {
        if (lease.unitsInfo.length === 0) {
          // eslint-disable-next-line no-await-in-loop
          const unitNamesResponse = await axios.post(`${UNITS_API_BASE}/names`, {
            units: lease.units,
          }, {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });

          const names = unitNamesResponse.data.result.names.map(unit => unit.name);
          // eslint-disable-next-line no-param-reassign
          lease.unitNames = [...names].toString();
        } else {
          const names = lease.unitsInfo.map(info => info.name);
          // eslint-disable-next-line no-param-reassign
          lease.unitNames = [...names].toString();
        }

        if (lease.customerId) {
          // eslint-disable-next-line no-await-in-loop
          const customerResponse = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/${lease.customerId}`, {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });
          
          lease.customer = customerResponse.data;
        }

      }
      this.pendingLeases = response.data;
    },
    async addedTodo() {
      this.addTodoDialog = false;
      this.loading = true;
      await this.getFacilityTodos();
      this.loading = false;
    },
    async getFacilityTodos() {
      const response = await axios.get(`${ADMIN_API_BASE}/todos`, {
        params: {
          facility: this.facility,
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.todos = response.data;
    },
  },
};
</script>

<style scoped>
.add-button {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/FacilityTodos.vue